import CallUI from "@/pages/session/CallUI";
import CheckoutPreview from "@/pages/checkout/CheckoutPreview";
import ContactUs from "@/pages/contact-us/ContactUs";
import Comments from "@/pages/dashboard/Comments";
import Conversations from "@/pages/dashboard/Conversations";
import DashboardDocuments from "@/pages/dashboard/DashboardDocuments";
import MyDashboard from "@/pages/dashboard/MyDashboard";
import MyBlogs from "@/pages/dashboard/MyBlogs";
import Transcations from "@/pages/dashboard/Transcations";
import GuideList from "@/pages/guide/GuideList";
import GuideProfile from "@/pages/guide/GuideProfile";
import GuideDashboard from "@/pages/guide/panel/GuideDashboard";
import Sessions from "@/pages/guide/panel/Sessions";
import MyStudents from "@/pages/guide/students/MyStudents";
import Guides from "@/pages/Guides";
import Plan from "@/pages/Plan";
import AdvaceProfileInformation from "@/pages/profile/AdvaceProfileInformation";
import AdvanceCarrierInformation from "@/pages/profile/AdvanceCarrierInformation";
import BasicProfileInformation from "@/pages/profile/BasicProfileInformation";
import Profile from "@/pages/profile/Profile";
import RefereeDetails from "@/pages/profile/RefereeDetails";
import StudyPreferences from "@/pages/profile/StudyPreferences";
import TravelDetails from "@/pages/profile/TravelDetails";
import MySession from "@/pages/session/MySession";
import Settings from "@/pages/Settings";
import TaskHomeCommon from "@/pages/tasks/TaskHomeCommon";
import CallLobby from "@/pages/session/CallLobby";
import MyAvailibilty from "@/pages/guide/panel/availability/MyAvailibilty";
import DayAvailibility from "@/pages/guide/panel/availability/DayAvailibility";
import GuideProfilePanel from "@/pages/guide/panel/profile/GuideProfilePanel";
import GuideProfileDetail from "@/pages/guide/panel/profile/GuideProfileDetail";
import SavedVideo from "@/pages/dashboard/SavedVideo";
import Notes from "@/pages/dashboard/Notes";
import Blogs from "@/components/homepage/BlogListing";
import MentorApply from "@/pages/common/MentorApply";
import BlogDetailRouter from "@/pages/blog/BlogDetailRouter";
import CreateBlog from "@/pages/blogs/create-blogs";
import { RecentBlogs } from "@/pages/blogs/recent-blogs";

export const studentRoutes = [
  {
    name: "guides",
    path: "/guides",
    isProtected: false,
    component: <Guides />,
  },
  {
    name: "guideList",
    path: "/guide-list",
    isProtected: false,
    component: <GuideList />,
  },
  {
    name: "guideProfile",
    path: "/guideProfile/:fullname/:countrycode/:id",
    isProtected: true,
    component: <GuideProfile />,
  },
  {
    name: "plan",
    path: "/plans",
    isProtected: false,
    component: <Plan />,
  },
  {
    name: "contact us",
    path: "/contact-us",
    isProtected: false,
    component: <ContactUs />,
  },
  {
    name: "sessions",
    path: "/sessions",
    isProtected: true,
    component: <MySession />,
  },
  {
    name: "Call UI",
    path: "/meeting/:id/:roomCode",
    isProtected: true,
    component: <CallUI />,
  },
  // {
  //   name: "Guide Looby",
  //   path: "/guide/lobby/:id",
  //   isProtected: true,
  //   component: <GuideLobby />,
  // },
  {
    name: "Call Lobby",
    path: "/lobby/:id",
    isProtected: true,
    component: <CallLobby />,
  },
  {
    name: "dashboard",
    path: "/dashboard",
    isProtected: true,
    component: <MyDashboard />,
  },
  {
    name: "dashboard conversation",
    path: "/dashboard/conversations",
    isProtected: true,
    component: <Conversations />,
  },
  {
    name: "dashboard comments",
    path: "/dashboard/comments/:id",
    isProtected: true,
    component: <Comments />,
  },
  {
    name: "dashboard tasks",
    path: "/dashboard/tasks",
    isProtected: true,
    component: <TaskHomeCommon />,
  },
  {
    name: "dashboard document",
    path: "/dashboard/documents",
    isProtected: true,
    component: <DashboardDocuments />,
  },
  {
    name: "dashboard transactions",
    path: "/transactions",
    isProtected: true,
    component: <Transcations />,
  },
  {
    name: "profile",
    path: "/profile",
    isProtected: true,
    component: <Profile />,
  },
  {
    name: "study prefrences",
    path: "/profile/study-preferences",
    isProtected: true,
    component: <StudyPreferences />,
  },
  {
    name: "basic contact information",
    path: "/profile/basic-contact-information",
    isProtected: true,
    component: <BasicProfileInformation />,
  },
  {
    name: "advance contact information",
    path: "/profile/advance-contact-information",
    isProtected: true,
    component: <AdvaceProfileInformation />,
  },
  {
    name: "advance carrer information",
    path: "/profile/advance-career-information",
    isProtected: true,
    component: <AdvanceCarrierInformation />,
  },
  {
    name: "advance travel details",
    path: "/profile/travel-details",
    isProtected: true,
    component: <TravelDetails />,
  },
  {
    name: "referee details",
    path: "/profile/referee-details",
    isProtected: true,
    component: <RefereeDetails />,
  },
  {
    name: "setting",
    path: "/setting",
    isProtected: true,
    component: <Settings />,
  },
  {
    name: "checkout preview",
    path: "/checkout-preview",
    isProtected: true,
    component: <CheckoutPreview />,
  },
  {
    name: "saved video",
    path: "/saved-video",
    isProtected: true,
    component: <SavedVideo />,
  },
  {
    name: "blogs",
    path: "/blogs",
    isProtected: false,
    component: <Blogs />,
  },
  {
    name: "blog detail",
    path: "/blog/:author/:slug/:id",
    isProtected: false,
    component: <BlogDetailRouter />,
  },
  {
    name: "mentor apply",
    path: "/mentor-apply",
    isProtected: false,
    component: <MentorApply />,
  },
];

/* mentor Routes */

export const guideRoutes = [
  {
    name: "guide Session",
    path: "/sessions",
    isProtected: true,
    component: <Sessions />,
  },
  {
    name: "guide dashboard",
    path: "/dashboard",
    isProtected: true,
    component: <GuideDashboard />,
  },
  {
    name: "dashboard conversation",
    path: "/dashboard/conversations",
    isProtected: true,
    component: <Conversations isGuidePanel />,
  },
  {
    name: "dashboard tasks",
    path: "/dashboard/tasks",
    isProtected: true,
    component: <TaskHomeCommon isGuidePanel />,
  },
  {
    name: "dashboard comments",
    path: "/dashboard/comments/:id",
    isProtected: true,
    component: <Comments />,
  },
  {
    name: "profile",
    path: "/profile",
    isProtected: false,
    component: <GuideProfilePanel />,
  },
  {
    name: "profile",
    path: "/profile/basic-contact-information",
    isProtected: false,
    component: <BasicProfileInformation />,
  },
  {
    name: "contact us",
    path: "/contact-us",
    isProtected: false,
    component: <ContactUs />,
  },
  {
    name: "advance contact information",
    path: "/profile/advance-contact-information",
    isProtected: true,
    component: <AdvaceProfileInformation />,
  },
  {
    name: "advance carrer information",
    path: "/profile/advance-career-information",
    isProtected: true,
    component: <AdvanceCarrierInformation />,
  },
  {
    name: "profile",
    path: "/profile/basic-profile-detail",
    isProtected: true,
    component: <GuideProfileDetail />,
  },
  {
    name: "my students",
    path: "/myStudents",
    isProtected: true,
    component: <MyStudents />,
  },
  {
    name: "my availibility",
    path: "/availability",
    isProtected: true,
    component: <MyAvailibilty />,
  },
  {
    name: "day availibility",
    path: "/availability/:id",
    isProtected: true,
    component: <DayAvailibility />,
  },
  {
    name: "setting",
    path: "/setting",
    isProtected: true,
    component: <Settings />,
  },
  {
    name: "saved video",
    path: "/saved-video",
    isProtected: true,
    component: <SavedVideo isGuidePanel />,
  },
  {
    name: "dashboard document",
    path: "/dashboard/documents",
    isProtected: true,
    component: <DashboardDocuments isGuidePanel />,
  },
  {
    name: "my blogs",
    path: "/dashboard/my-blogs",
    isProtected: true,
    component: <MyBlogs />,
  },
  {
    name: "my notes",
    path: "/notes",
    isProtected: true,
    component: <Notes />,
  },
  {
    name: "blogs",
    path: "/blogs",
    isProtected: false,
    component: <Blogs />,
  },
  {
    name: "blog detail",
    path: "/blog/:author/:slug/:id",
    isProtected: false,
    component: <BlogDetailRouter />,
  },
  {
    name: "mentor apply",
    path: "/mentor-apply",
    isProtected: false,
    component: <MentorApply />,
  },
  {
    name: "create blog",
    path: "/create-blog",
    isProtected: true,
    component: <CreateBlog />,
  },
  // recent
  {
    name: "recent blog",
    path: "/recent-blogs",
    isProtected: true,
    component: <RecentBlogs />,
  },
];
